var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1036,
    height: 340,
    viewBox: "0 0 1036 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412 53.9999C751 225 783.395 -87.4164 930.757 181C1078.12 449.416 688 574 962 753C1236 932 675 1053 480 825C285 597 87.4482 831.094 -51.127 734.926C-189.702 638.758 148 387 6.99985 276C-134 165 72.9998 -117 412 53.9999Z",
    fill: "url(#paint0_linear_1611_4168)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1611_4168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -86,
    y: 0,
    width: 1122,
    height: 950
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412 53.9999C751 225 783.395 -87.4164 930.757 181C1078.12 449.416 688 574 962 753C1236 932 675 1053 480 825C285 597 87.4482 831.094 -51.127 734.926C-189.702 638.758 148 387 6.99985 276C-134 165 72.9998 -117 412 53.9999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1611_4168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 638.83,
    cy: 566.28,
    rx: 189.83,
    ry: 278.28,
    fill: "#673AB7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 472.78,
    cy: 471.347,
    rx: 215.781,
    ry: 489.347,
    transform: "rotate(41 472.78 471.347)",
    fill: "url(#paint1_linear_1611_4168)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 861.5,
    cy: 397.5,
    rx: 191.5,
    ry: 380.5,
    fill: "url(#paint2_linear_1611_4168)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.327,
    cy: 430.014,
    rx: 215.781,
    ry: 489.347,
    transform: "rotate(41 267.327 430.014)",
    fill: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.5,
    cy: 287.764,
    rx: 137.8,
    ry: 289.467,
    transform: "rotate(41 133.5 287.764)",
    fill: "url(#paint3_linear_1611_4168)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.9996,
    cy: 163.5,
    rx: 118,
    ry: 207,
    transform: "rotate(41 41.9996 163.5)",
    fill: "#D1C4E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1611_4168",
    x1: 450.552,
    y1: -687.488,
    x2: -492.173,
    y2: 715.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2EBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C4E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1611_4168",
    x1: 205.41,
    y1: -45.9068,
    x2: -98.198,
    y2: 910.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673AB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1611_4168",
    x1: 529.447,
    y1: 620.874,
    x2: 1127.71,
    y2: 794.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E91E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BBD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1611_4168",
    x1: 103.172,
    y1: -289.972,
    x2: -305.516,
    y2: 28.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673AB7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/loginBackground.0aa2d63e69fbdf936731add213e9bcc1.svg";
export { ForwardRef as ReactComponent };